<template>
  <div class="home mx-auto max-w-lg text-center">
    <div class="text-news-black my-6">
      <h2 class="text-5xl font-serif">Penfield</h2>
      <p class="inline-block text-xl font-serif tracking-wider py-y border-t border-b border-gray-400">COUNTRY CLUB</p>
    </div>
    <img class="inline-block max-w-sm" alt="Vue logo" src="../assets/shankertational-hawk.jpg">
    <div class="font-serif text-news-black my-4">
      <p class="text-2xl">2026</p>
      <h1 class="text-2xl md:text-3xl tracking-wide">SHANKERTATIONAL</h1>
    </div>

    <div v-for="flight in this.tournament?.leaderboard.flights" :key="flight.name">
      <leaderboard :flight-name="flight.name"  :teams="flight.teams" class="mb-8"></leaderboard>
    </div>


    <div class="my-8 text-sm px-4">
      <p class="mb-4 text-sm px-4">Scoring is based on total match points each day.</p>
      <p class="mb-4 text-sm px-4">Tournament fee is split evenly into 4 pots, one for each day and one for overall. Payouts each day and overall per flight: 1st (50%), 2nd (30%), 3rd (20%)</p>
      <p>For more info, contact the site administrator. If you don't know who the site admin is, you don't need to contact him.</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Leaderboard from "@/components/Leaderboard";

export default {
  name: 'Home',
  components: {
    Leaderboard,
  },
  mounted: async function(){
    this.loadTournament().then((tournament) => {
      this.tournament = tournament;
      console.log("tournament data",tournament);
    }).catch((e) => {
      console.log(e);
    })

  },
  data: function() {
    return  {
      tournamentId: 1,
      tournament: null,
      name: 2026,
      leaderboard:{
        "flights": [
          {
            "name": "Bushwood",
            "teams": [
              { "name": "Carter/Carter", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Shearer/Utter", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Kay/Velardo", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Allen/Allen", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Drews/Sexton", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Murray/Buggy", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Cortina/Blount", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Burke/Ogden", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Barto/Guglani", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Wagner/Feltner", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Short/Riley", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } }
            ]
          },
          {
            "name": "Duffers",
            "teams": [
              { "name": "Holden/Bartolotta", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Wolak/Wolak", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Battles/Williams", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Greenwood/Engels", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Stoler/Emmick", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Meng/Meng", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Chantra/Howcroft", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Spags/Murphy", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Barbato/Watters", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Ball/Lozipone", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } },
              { "name": "Viola/Mallon", "scores": { "day1": 0, "day2": 0, "day3": 0, "overall": 0 } }
            ]
          }
        ]
      }



    }
  },
  methods: {

    loadTournament: function(){


      return this.$db.from("tournaments").select("*").eq('id',1).single().then((response) => {

        console.log("tournament",response);
        if(response.data){
          let record = response.data;
          return record;
        }else{
          throw new Error("Document error.");
        }
      })
    },


  },
  computed: {

  }

}
</script>

<style scoped>
  .home {

  }
</style>
